export const FILE = 'file';
export const SINGLE_FILE = 'singleFile';
export const FILE_TYPES = [FILE, SINGLE_FILE];
export const TEXT_BLOCK_LONG = 'textBlockLong';
export const TEXT_AREA = 'textarea';
export const REMINDER = 'reminder';
export const STYLED_INPUT_QUESTIONS = ['textarea', 'textBlockLong'];
